/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePractitioner200ResponseDataPractitioner
 */
export interface CreatePractitioner200ResponseDataPractitioner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    first_name: string;
    /**
     * 
     */
    last_name: string;
    /**
     * 
     */
    npi: string | null;
    /**
     * 
     */
    credential?: string | null;
    /**
     * 
     */
    address_line?: string | null;
    /**
     * 
     */
    city?: string | null;
    /**
     * 
     */
    state?: string | null;
    /**
     * 
     */
    zip?: string | null;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    fax?: string | null;
}

/**
 * Check if a given object implements the CreatePractitioner200ResponseDataPractitioner interface.
 */
export function instanceOfCreatePractitioner200ResponseDataPractitioner(value: object): value is CreatePractitioner200ResponseDataPractitioner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('npi' in value) || value['npi'] === undefined) return false;
    return true;
}

export function CreatePractitioner200ResponseDataPractitionerFromJSON(json: any): CreatePractitioner200ResponseDataPractitioner {
    return CreatePractitioner200ResponseDataPractitionerFromJSONTyped(json, false);
}

export function CreatePractitioner200ResponseDataPractitionerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePractitioner200ResponseDataPractitioner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'npi': json['npi'],
        'credential': json['credential'] === undefined ? undefined : json['credential'] === null ? null : json['credential'],
        'address_line': json['address_line'] === undefined ? undefined : json['address_line'] === null ? null : json['address_line'],
        'city': json['city'] === undefined ? undefined : json['city'] === null ? null : json['city'],
        'state': json['state'] === undefined ? undefined : json['state'] === null ? null : json['state'],
        'zip': json['zip'] === undefined ? undefined : json['zip'] === null ? null : json['zip'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'fax': json['fax'] === undefined ? undefined : json['fax'] === null ? null : json['fax'],
    };
}

export function CreatePractitioner200ResponseDataPractitionerToJSON(json: any): CreatePractitioner200ResponseDataPractitioner {
    return CreatePractitioner200ResponseDataPractitionerToJSONTyped(json, false);
}

export function CreatePractitioner200ResponseDataPractitionerToJSONTyped(value?: CreatePractitioner200ResponseDataPractitioner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'npi': value['npi'],
        'credential': value['credential'],
        'address_line': value['address_line'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'phone': value['phone'],
        'fax': value['fax'],
    };
}

